import React from 'react'
import { MDBRadio } from 'mdb-react-ui-kit'
import { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { applicationContextRoot, datePickerAppDate, handleSessionUrl, MISReportDateFormat } from '../../../constants/constants';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import { getLoginInfoUrl, getSurveybyId, apiHostUrl } from '../../../constants/constants';
import { setUserInfo } from '../../system/redux/reducers/roleReducer';
import { setMenuInfo } from '../../system/redux/reducers/menuReducer';
import { useTranslation } from 'react-i18next';
import { setSurveyInfo } from '../../system/redux/reducers/surveyReducer';
import { setPayloadData, setSearchFilterData } from '../../system/redux/reducers/NavigatedDataReducer';
import moment from 'moment/moment';

const MultiSessionForm = ({ onErrorFromLogin, param }) => {
    debugger;
    const [responseSuveyQuestion, setResponseSuveyQuestion] = useState();
    const [responseSuveyQuestionParam, setResponseSuveyQuestionParam] = useState();
    const surveyURLbyId = apiHostUrl + getSurveybyId;
    const { i18n, t } = useTranslation();
    const [isCheckedOne, setIsCheckedOne] = useState(false);
    const [isCheckedTwo, setIsCheckedTwo] = useState(true);
    const [menu, setMenu] = useState([]);
    const { csrfHeaderName, csrfFormTagName, csrfToken } = useSelector((state) => state.csrf);
    const navigate = useNavigate();
    const [previous, setPrevious] = useState(false);
    const dispatch = useDispatch();

    const onTrigger = () => {
        onErrorFromLogin("Invalidated Current Session");
        console.log('input');
    };

    const userData = {
        userEmail: '',
        homeLink: '',
        roles: []
    };

    const menuData = {
        menuItems: [],
    }


    const handleNavigation = (param) => {
        console.log("Inside Navigation" + previous);
        if (!previous) {
            navigate(applicationContextRoot);
        }
        else {
            navigate(applicationContextRoot + '/home');
        }
    }
    const headers1 = {
        'Accept': '*/*',
        'Content-Type': 'application/x-www-form-urlencoded',
        'Access-Control-Allow-Credentials': true,
        'X-CSRF-TOKEN': csrfToken,
        'redirect': 'false'
    };

    const handleCheckboxChange = (event) => {


        if (event.target.id === 'flexRadioDefault1') {
            console.log(event.target.id);
            setIsCheckedOne(true);
            setIsCheckedTwo(false);
            setPrevious(true);
        }
        else {
            setIsCheckedOne(false);
            setIsCheckedTwo(true);
            setPrevious(false);
        }
    };


    const getUserInfo = (res) => {
        axios.get(getLoginInfoUrl, { withCredentials: true },)
            .then(response => {
                console.log("Inside login Info");
                userData.userEmail = response.data.userEmail;
                userData.homeLink = response.data.homeLink;
                userData.roles = response.data.userRoles;
                userData.userName = response.data.userName;
                userData.userCurrRole = { ...response.data.userCurrRole };
                userData.isChatEnabled = response.data.isChatEnabled;
                userData.isBotChatEnabled = response.data.isBotChatEnabled;
                userData.isAgentChatEnabled = response.data.isAgentChatEnabled;
                userData.isFAQEnabled = response.data.isFAQEnabled;
                userData.isWorkingTime = response.data.isWorkingTime;
                userData.workingHoursList = response.data.workingHoursList;
                userData.serviceUserId = response.data.serviceUserId;
                setMenu(response.data.menus);
                const localD = response.data.menus;
                menuData.menuItems = localD;
                console.log(userData);
                dispatch(setUserInfo(userData));
                dispatch(setMenuInfo(menuData));
                console.log(menuData);
                handleNavigation();
            })
            .catch(err => {
                console.log(err);
            });
    }
    const handleNavigateParam = () => {
        debugger;
        if (typeof param === "string") {
            axios.get(surveyURLbyId + "/" + param, { withCredentials: true }, headers1,
            ).then((response) => {
                setResponseSuveyQuestionParam(response)
                const responsead = response;
                console.log(response);
                console.log('Survey')
                console.log(responseSuveyQuestion);
                
            });
        }

    };

    useEffect(() => {

        console.log('Inside multisession of survey');
        console.log(responseSuveyQuestionParam);
        debugger
        if (responseSuveyQuestionParam?.data?.surveyList?.length > 0) {
            dispatch(setSurveyInfo(responseSuveyQuestionParam));
            const serializedData = JSON.stringify(responseSuveyQuestionParam);
            const id = serializedData?.data?.surveyList[0]?.id;
            console.log('Going to navigate to survey form with id:', id);
            navigate(applicationContextRoot + '/survey/launch-survey/');
        } else {
            console.error('No survey data found in responseSuveyQuestionParam');
            // Handle the case when there is no survey data
        }
    }, [responseSuveyQuestionParam])

    const handleSession1 = (event) => {

        let payloadData = "previous";
        if (isCheckedTwo) {
            payloadData = "current";
        }
        else if (isCheckedOne) {
            payloadData = "previous";
        }

        debugger
        console.log("Inside multisessionclick");
        console.log(csrfFormTagName);
        const formData = csrfFormTagName + "=" + csrfToken + "&invalidateSession=" + payloadData;
        axios.post(handleSessionUrl, formData, { withXSRFToken: true, withCredentials: true }, headers1,
        ).then((response) => {
            const responsead = response.request.responseURL;

            const today = moment().format(datePickerAppDate)
            var formattedDateToday = moment(today, datePickerAppDate).format(MISReportDateFormat);

            const toDateFormatted = formattedDateToday;
            console.log(toDateFormatted);
            //const fromDateCopy = new Date(today);
            //fromDateCopy.setDate(today.getDate() - 90);
            const fromDateFormatted = moment().subtract(3, 'month').format(datePickerAppDate);
            var formattedDateFrom = moment(fromDateFormatted, datePickerAppDate).format(MISReportDateFormat);
            const fromDate = formattedDateFrom;

            const searchFilterData = {
                "status": 'All',
                'toDate': toDateFormatted,
                'fromDate': fromDate
            };
            dispatch(setPayloadData({}));
            dispatch(setSearchFilterData(searchFilterData));
            console.log(responsead + "session");
            if (responsead.includes("get-mfa")) {
                onErrorFromLogin("Otp sent Successfully");
            }
            else {
                if (param) {
                    if (isCheckedOne) {
                        console.log('Inside multisession of survey');
                        handleNavigateParam();

                    }
                    else{
                        if (response.request.status === 200) {
                           window.location.reload();
                   }
                    }
                } else {
                    onTrigger();
                    getUserInfo();

                    if (response.request.status === 200) {
                    window.location.reload();
                   }
                }
                
            }
        });


    }


    return (
        <>
            <div>
                <div className='mb-3'>
                    <MDBRadio name='flexRadioDefault'
                        id='flexRadioDefault1'
                        label={t("general.label.logout.prevstate")}
                        checked={isCheckedOne}
                        onClick={handleCheckboxChange}
                    />
                    <MDBRadio name='flexRadioDefault'
                        id='flexRadioDefault2'
                        label={t('general.label.logout.current')}
                        checked={isCheckedTwo}
                        onClick={handleCheckboxChange}
                    />
                </div>

                <button
                    data-mdb-ripple-init=""
                    type="submit"
                    className="btn btn-primary btn-block w-100"
                    onClick={handleSession1}

                >
                    {t("general.button.submit.label")}
                </button>

            </div>
        </>
    )
}
export default MultiSessionForm;